import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { TextColorCheck } from '../utils/textColorCheck';

import './hero.scss';

const COMPONENT_NAME = 'hero';
const BEM = {
  BLOCK: COMPONENT_NAME,
};

/**
 * version    1.0
 * class      <type> (Hero)
 */
export class Hero {
  constructor() {
    const self = this;

    this._els = {
      hero: $(`.${BEM.BLOCK}`),
    };

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      self._els.hero.each(function () {
        const $instanceEl = $(this);
        TextColorCheck._checkBackground($instanceEl);
      });
    });
  }
}
